import { InfoBox, Property, StatusBadge } from "../ui";
import { formatDateTime } from "../scholarships/review/model";

const fullName = (record) => [record.firstName, record.lastName].filter(Boolean).join(" ") || undefined;

// The student's request and its decision, as the API answers it (a selection's grant shows once approved)
export default function LoanStatusTab({ bursary }) {
  const { record, request } = bursary;
  if (!request) {
    return <InfoBox>You have not applied for a local loan yet.</InfoBox>;
  }
  return (
    <div className="flex max-w-2xl flex-col gap-5">
      <div>
        <Property label="Names" value={fullName(record)} />
        <Property label="Registration number" value={record.registrationNumber} />
        <Property label="Index number" value={record.indexNumber} />
        <Property label="Study area" value={request.studyArea} />
        <Property label="Loan category" value={request.loanCategory} />
        <Property label="Total score" value={request.totalScore ?? undefined} />
        <Property label="Status" value={<StatusBadge status={request.status} />} />
        <Property label="Requested on" value={formatDateTime(request.requestedAt)} />
        {request.decidedAt && <Property label="Decided on" value={formatDateTime(request.decidedAt)} />}
        {request.decisionReason && <Property label="Reason" value={request.decisionReason} />}
      </div>
      {request.status === "PENDING" && <InfoBox>Your request is being reviewed. Its decision shows here as soon as it is published.</InfoBox>}
    </div>
  );
}
